import {
    Box,
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalCloseButton,
    Text,
    VStack,
} from '@chakra-ui/react';
import React from 'react';

export interface PartNumberChoiceIssue {
    partNumber?: string;
    issueDetails?: {
        suggestedPartNumber?: string;
        invoiceDescription?: string;
        invoicePartName?: string;
        nexDescription?: string;
        nexPartName?: string;
    };
}

export interface InvoicePartNumberChoiceModalProps {
    isOpen: boolean;
    onClose: () => void;
    issue: PartNumberChoiceIssue | null;
    onUseNexPart: () => void;
}

export default function InvoicePartNumberChoiceModal(props: InvoicePartNumberChoiceModalProps) {
    const { isOpen, onClose, issue, onUseNexPart } = props;
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Choose part number</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="sm" color="gray.600" mb={4}>Invoice and NEX have different part numbers for this line.</Text>
                    {issue && (
                        <VStack align="stretch" spacing={4}>
                            <Box bg="gray.50" p={4} borderRadius="md">
                                <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={2}>INVOICE</Text>
                                <Text fontFamily="mono" fontWeight="semibold">{issue.partNumber}</Text>
                                {(issue.issueDetails?.invoiceDescription || issue.issueDetails?.invoicePartName) && (
                                    <Text fontSize="sm" color="gray.600" mt={1}>{issue.issueDetails?.invoiceDescription ?? issue.issueDetails?.invoicePartName}</Text>
                                )}
                            </Box>
                            <Box bg="blue.50" p={4} borderRadius="md">
                                <Text fontSize="xs" fontWeight="bold" color="blue.600" mb={2}>NEX</Text>
                                <Text fontFamily="mono" fontWeight="semibold">{issue.issueDetails?.suggestedPartNumber}</Text>
                                {(issue.issueDetails?.nexDescription || issue.issueDetails?.nexPartName) && (
                                    <Text fontSize="sm" color="gray.600" mt={1}>{issue.issueDetails?.nexDescription ?? issue.issueDetails?.nexPartName}</Text>
                                )}
                            </Box>
                        </VStack>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button size="action" variant="ghost" mr={3} onClick={onClose}>Keep invoice part</Button>
                    <Button size="action"
                            bg="#0071E3"
                            color="white"
                            _hover={{ bg: '#3544a0' }} onClick={onUseNexPart}>Use NEX part number</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
